"use client";

import { createContext, useContext, useState } from "react";

const FormContext = createContext();

export const FormProvider = ({ children }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [shouldDownload, setShouldDownload] = useState(false);

    const [brochure, setBrochure] = useState({
        url: "",
        filename: "",
    });

    const [modal, setModal] = useState({ open: false, url: "" });


    //   Download
    const handleDownload = () => {

        if (!brochure.url) return;

        const link = document.createElement("a");

        link.href = brochure.url;

        link.download =
            brochure.filename || "brochure.pdf";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    //   Open Modal
    const openDownloadForm = (url, filename) => {
        setBrochure({
            url,
            filename,
        });
        setShouldDownload(true);
        setIsOpen(true);
    };

    const openApplyForm = () => {
        setShouldDownload(false);
        setIsOpen(true);
    };

    const closeForm = () => {
        setIsOpen(false);
    };

    // On Success

    const handleSuccess = () => {

        if (shouldDownload) {
            handleDownload();
            setShouldDownload(false);
            setBrochure({
                url: "",
                filename: "",
            });
        }
    };

    // Open Video
    const openVideo = (url) => {
        setModal({
            open: true,
            url,
        });
    };

    // Close Video
    const closeVideo = () => {
        setModal({
            open: false,
            url: "",
        });
    };

    return (

        <FormContext.Provider
            value={{
                isOpen,
                shouldDownload,
                openDownloadForm,
                openApplyForm,
                closeForm,
                handleSuccess,
                modal,
                openVideo,
                closeVideo,
            }}
        >

            {children}

        </FormContext.Provider>

    );
};

export const useFormModal = () =>
    useContext(FormContext);